@for (article of articles()?.data?.stories; track article) {
    <s1-article-preview class="s1-articles-view--item"
                        [block]="article" />
}
